// extracted by mini-css-extract-plugin
export default {"matchesInfo":"matches_panel-module___matchesInfo___cd5989bd"};